module.exports = __webpack_public_path__ + "img/btn_last-track.5dd664c1.svg";